import queryString from 'query-string'

const useQuerystring = () =>
  queryString.parse(location.search, {
    parseNumbers: true,
    parseBooleans: true,
  })
export default useQuerystring
